<template>
  <div class="wrap">
    <div class="wrap_shadow">
      <h3>생생 로이터 동영상 뉴스 이렇게 학습하세요.</h3>
      <div class="shadowing">
        <div class="sha_txt sha_txt_div">
          <ul>
            <li class="t_bold">
              <span class="lt_style"></span><p class="blue">쉐도잉(Shadowing)</p> 이란?
            </li>
            <li><strong>외국어 청취시, 원어민의 말을 그림자처럼 따라 하는 기법입니다.</strong></li>
            <li>듣기 훈련방법 중 가장 효과적인 방법이라고 할 수 있습니다.</li>
            <li>
              <p class="blue">쉐도잉</p>연습을 할 때 가장 주의해야 할 점은 해석하려고 하지 않는 것입니다. 그냥 듣고 따라 읽는 데만 집중하면 됩니다.
            </li>
            <li>마치 자신이 원어민이 된듯 원어민의 발음과 리듬까지 최대한 비슷하게 흉내내야 합니다.</li>
            <li>
              <p class="blue">쉐도잉</p>을 하는 동안 집중도가 향상되고 뇌가 최고조 활성화 됨으로써 원어민의 발음, 억양, 악센트를 그대로 습득할 수 있습니다.
            </li>
            <li><span class="yellow_box">※ 이 방법은 동시통역사 훈련에서 사용되는 훈련기법입니다.</span></li>
          </ul>
      </div>
    </div>
  </div>
  </div>
</template>
<script>
export default {

  mounted () {
    document.title = '학습가이드 보기'
  }

}
</script>
<style scoped>
@import '../../assets/scss/4step_guide.css';
</style>



// WEBPACK FOOTER //
// src/pages/cafe/guideSnew.vue